import { useMemo } from "react";
import { useParams } from "react-router-dom";
import type { ProductEntry } from "../products";
import { getProductsForFeatureFlags } from "../products";
import { useMerchantInfo } from "./use-merchant-info";

export function useProduct(): ProductEntry | undefined {
  const { productId } = useParams<{ productId: string }>();
  const { featureFlags } = useMerchantInfo();

  return useMemo(() => {
    if (!productId) {
      return undefined;
    }
    return getProductsForFeatureFlags(featureFlags).find(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      (product) => product.id === (productId as ProductEntry["id"]),
    );
  }, [featureFlags, productId]);
}
